import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { PrevTaawValues } from '@/types';
import { createSlice } from '@reduxjs/toolkit';

interface ScwsState {
  scwData: string | null;
  prioritized: boolean;
  taawValues: PrevTaawValues | null;
  taaw: string | null;
  lops: string | null;
  productType: string | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: ScwsState = {
  scwData: null,
  prioritized: false,
  taawValues: null,
  taaw: null,
  lops: null,
  productType: null,
  isRegenerated: undefined,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'scws',
  initialState,
  reducers: {
    setScwData(state, action) {
      state.scwData = action.payload.answer;
      state.prioritized = action.payload.prioritized;
      state.taawValues = action.payload.taawValues;
      state.taaw = action.payload.taaw;
      state.lops = action.payload.lops;
      state.productType = action.payload.productType;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setScwData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setScwData, setTitle };

export const selectScwData = (state: State) => state[name];
export const selectScwIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectScwTitle = (state: State) => state[name].title;
